import axios from 'axios';
import loaderService from './../components/loader/loader.service';
import { CommonInfo } from '../CommonData/Config';
import ToastrService from './../components/toaster/ToastrService';

const Commondata = CommonInfo;

const axiosInstance = axios.create({
    baseURL: localStorage.getItem('authToken'), // Set your API base URL
    headers: {
        'X-Requested-With': 'com.resourcexpress.mobilekiosk',
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': localStorage.getItem('authToken')
    }
});

const updateAuthToken = () => {
    const authToken = localStorage.getItem('authToken');
    axiosInstance.defaults.headers['Authorization'] = authToken;
};

// Call the function initially to set the authentication token

axiosInstance.interceptors.request.use(
    (config) => {
        loaderService.showLoader(); // Show loader
        return config;
    },
    (error) => {
        loaderService.hideLoader(); // Hide loader on request error
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        loaderService.hideLoader();
        return response;
    },
    (error) => {
        loaderService.hideLoader();

        if (error.response && error.response.status === 401) {
            // Handle 401 Unauthorized error
            ToastrService.error(error.message);
            Commondata.resetValues();
            setTimeout(() => {
                window.location.href = "/login";
            }, 1000); // Adjust the delay as needed
            // You may want to handle logout or token refresh here
        } else if ([403, 503].includes(error.response && error.response.status)) {
            // Handle 403 Forbidden error
            ToastrService.error(error.message);
            // Adjust the delay as needed
        } else if ([404, 504].includes(error.response && error.response.status)) {
            // Handle 404 Not Found error
            ToastrService.error(error.message);
            // Adjust the delay as needed
        } else {
            // Handle other errors
            // Example: show a generic error message
            ToastrService.error(error.response.data.Message);
            // Adjust the delay as needed
        }

        // Return the error to the method that called it
        return Promise.reject(error);
    }

);

export { axiosInstance, updateAuthToken };
